import {
    Component,
    Prop,
    Host,
    Element,
    Listen,
    h,
    State,
} from "@stencil/core";

@Component({
    tag: "ux-iws-form-loader",
})
export class FormLoader {
    private formElement: HTMLFormElement = null;

    @Element() element: HTMLUxIwsFormLoaderElement;

    /** if set, the component will use this string as css selector to look for elements to disable */
    @Prop() buttonsToDisable: string | null = null;
    /** the target element to insert the loader */
    @Prop() loaderTarget: string | null = null;
    /** defines the position for the loader to be inserted at. See position parameter at https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentHTML#parameters */
    @Prop() loaderInsertPosition: InsertPosition = "beforebegin";
    /** the offset margin to prevent layout shift when insertin the loader */
    @Prop() loaderMarginOffset: number = 0;

    @State() spinnerInserted: boolean = false;
    @State() submitListenerSet: boolean = false;

    connectedCallback() {
        this.formElement = this.element.closest("form");
    }

    disconnectedCallback() {
        if (this.submitListenerSet === true) {
            this.formElement.removeEventListener("submit", this.handleSubmit);
        }
    }

    private disableSubmitButtons = () => {
        const submitButtons = this.formElement.querySelectorAll(
            this.buttonsToDisable || "*[type='submit']"
        );
        submitButtons.forEach(
            (button: HTMLButtonElement | HTMLInputElement) => {
                button.classList.add("ux-u-opacity-30");
                button.style.pointerEvents = "none";
                button.setAttribute("aria-disabled", "true");
            }
        );
    };

    private spinnerSubmitButton = () => {
        if (this.spinnerInserted) return;
        const submitButton = this.formElement.querySelector("*[type='submit']");
        const spinnerTarget = this.loaderTarget
            ? this.formElement.querySelector(this.loaderTarget)
            : submitButton;
        spinnerTarget.insertAdjacentHTML(
            this.loaderInsertPosition,
            `<span style="display: block; max-height: 0px; height: 0px; overflow: visible; margin-top: -${this.loaderMarginOffset}px; margin-bottom: ${this.loaderMarginOffset}px;">
                <ux-loader style="display: block;" variant="horizontal"></ux-loader>
            </span>`
        );
        this.spinnerInserted = true;
    };

    private handleSubmit = (e: Event) => {
        if (e && !e?.defaultPrevented) {
            this.disableSubmitButtons();
            this.spinnerSubmitButton();
        }
    };

    @Listen("click", { target: "window" })
    handleSubmitButtonAttributes(e: Event) {
        const eTarget = e.target as HTMLElement;
        if (!this.formElement.contains(eTarget)) return;
        if (this.submitListenerSet === true) return;
        this.formElement.addEventListener("submit", this.handleSubmit);
        this.submitListenerSet = true;
    }

    render() {
        return <Host style={{ display: "none" }}></Host>;
    }
}
